import React from 'react'

import { Funds } from 'src/components/AdminPanel/funds'

export const FundsPage = () => <Funds />
